import { computed } from 'vue';

import { useRoute } from 'vue-router';

export const getComputedNavLinkToProp = computed(() => (link) => {
  const route = useRoute();
  const props = {
    target: link.target,
    rel: link.rel,
  };

  // If route is string => it assumes string is route name => Create route object from route name
  // If route is not string => It assumes it's route object => returns passed route object
  if (link.to) {
    const baseRoute = typeof link.to === 'string' ? { name: link.to } : link.to;

    // Preserve the marketplace + business-profile intent across in-app navigation. `marketplace`
    // (uid) is the canonical param and the only one a seller-only marketplace carries; `profileId`
    // is the legacy ads mirror, kept for old links/tabs.
    const preservedQuery = {};
    if (route.query.marketplace) {
      preservedQuery.marketplace = route.query.marketplace;
    }
    if (route.query.profileId) {
      preservedQuery.profileId = route.query.profileId;
    }
    if (route.query.businessProfileId) {
      preservedQuery.businessProfileId = route.query.businessProfileId;
    }

    // Merge preserved query parameters with existing route query
    props.to = {
      ...baseRoute,
      query: {
        ...baseRoute.query,
        ...preservedQuery,
      },
    };
  } else {
    props.href = link.href;
  }

  return props;
});

export const resolveNavLinkRouteName = (link, router) => {
  if (!link.to) return null;
  if (typeof link.to === 'string') return link.to;

  return router.resolve(link.to).name;
};

export const isNavLinkActive = (link, router) => {
  // Matched routes array of current route
  const matchedRoutes = router.currentRoute.value.matched;

  // Check if provided route matches route's matched route
  const resolveRoutedName = resolveNavLinkRouteName(link, router);
  if (!resolveRoutedName) return false;

  return matchedRoutes.some((route) => {
    return route.name === resolveRoutedName || route.meta.navActiveLink === resolveRoutedName;
  });
};

export const isNavGroupActive = (children, router) =>
  children.some((child) => {
    // If child have children => It's group => Go deeper(recursive)
    if ('children' in child) return isNavGroupActive(child.children, router);

    // else it's link => Check for matched Route
    return isNavLinkActive(child, router);
  });

export const hexToRgb = (hex) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

  hex = hex.replace(shorthandRegex, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}`
    : null;
};

export const rgbaToHex = (rgba, forceRemoveAlpha = false) => {
  return `#${rgba
    .replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
    .split(',') // splits them at ","
    .filter((string, index) => !forceRemoveAlpha || index !== 3)
    .map((string) => parseFloat(string)) // Converts them to numbers
    .map((number, index) => (index === 3 ? Math.round(number * 255) : number)) // Converts alpha to 255 number
    .map((number) => number.toString(16)) // Converts numbers to hex
    .map((string) => (string.length === 1 ? `0${string}` : string)) // Adds 0 when length of one number is 1
    .join('')}`;
};
